module.exports = __webpack_public_path__ + "img/title.3118cf2a.png";